import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { IParameter, IParamSearch } from 'src/app/models/parameter';
import { ApiParameterService } from './../../../services/api/api-parameter.service';
import { DataService } from 'src/app/services/data.service';
import { IFilterParams } from '../../../models/filters';
import { DialogEmailTypeEnum } from 'src/app/models/email';

@Component({
  selector: 'app-configuracoes-parametros',
  templateUrl: './configuracoes-parametros.component.html',
  styleUrls: ['./configuracoes-parametros.component.scss']
})
export class ConfiguracoesParametrosComponent implements OnInit {
  typeCard = 3;
  queryField = new FormControl<string>('', { nonNullable: true });
  search: string = '';
  filter!: IFilterParams;

  DialogEmailTypeEnum = DialogEmailTypeEnum;

  headerParametros = [
    { label: 'Nome do Parâmetro', flexSize: 3, justify: 'flex-start' },
    { label: 'Valor', flexSize: 3 },
    { label: '', flexSize: 2 }
  ];

  parametersList: IParameter[] = [];

  constructor(
    private _dataService: DataService,
    private _parameterService: ApiParameterService
  ) {}

  ngOnInit(): void {
    this.getAllParameters();
  }

  searchField(text: string): void {
    let formattedString = text
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '');
    this.search = formattedString;

    this.getAllParameters();
  }

  buildFilter(): void {
    this._dataService.listParameters.subscribe((filter) => {
      this.filter = filter;
    });
  }

  private getAllParameters(): void {
    const searchData: IParamSearch = {
      Text: this.search
    };

    this._parameterService.getAllParameters(searchData).subscribe({
      next: (response) => {
        this.parametersList = response.Data;
      }
    });
  }

  handlerUpdateParameter(parameter: IParameter): void {
    let index: number = this.parametersList.findIndex(
      (param: IParameter) => param.ParameterId === parameter.ParameterId
    );

    if (index >= 0) this.parametersList[index] = parameter;
  }
}
